//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalSelection from '~/components/molecules/Editorial/Global/GlobalSelection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'GlobalFooter',
  components: {
    GlobalSelection,
    GlobalRichText,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref11, _ref12, _ref13, _ref14, _ref15, _ref16;

      return {
        background: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.background_color : _ref16 : _ref16) || '',
        textColor: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.text_color : _ref15 : _ref15) || '',
        title: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.rich_text : _ref14 : _ref14) || [],
        subtitle: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.subtitle : _ref13 : _ref13) || [],
        paragraph: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.paragraph : _ref12 : _ref12) || [],
        is_last_element: (_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.is_last_element : _ref11 : _ref11,
        selections: this.payload.items.map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

          return {
            url: ((_ref10 = i) != null ? (_ref10 = _ref10.url) != null ? _ref10.url : _ref10 : _ref10) || '',
            textColor: ((_ref9 = i) != null ? _ref9.text_color : _ref9) || '',
            title: ((_ref8 = i) != null ? (_ref8 = _ref8.title) != null ? _ref8[0] : _ref8 : _ref8) || null,
            description: ((_ref7 = i) != null ? _ref7.description : _ref7) || null,
            cta: ((_ref6 = i) != null ? _ref6.cta : _ref6) || '',
            image: {
              small: formatPrismicImage((_ref5 = i) != null ? (_ref5 = _ref5.background_image) != null ? (_ref5 = _ref5.small) != null ? _ref5.url : _ref5 : _ref5 : _ref5, ['w_90,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref4 = i) != null ? (_ref4 = _ref4.background_image) != null ? (_ref4 = _ref4.large) != null ? _ref4.url : _ref4 : _ref4 : _ref4, ['w_375,dpr_2']) || EMPTY_PIXEL
            },
            tracking: {
              data: {
                event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
              }
            }
          };
        })
      };
    },

    theParagraph() {
      return this.currentPayload.paragraph && this.currentPayload.paragraph[0] && this.currentPayload.paragraph[0].text;
    },

    countSelections() {
      return this.currentPayload.selections.length;
    },

    isLastElement() {
      return this.currentPayload.is_last_element ? 'pb-0' : null;
    },

    dynamicColumns() {
      switch (this.countSelections) {
        case 1:
          return 'col-md-5';

        case 2:
          return 'col-md-5';

        case 3:
          return 'col-md-4';

        default:
          return 'col-md-3';
      }
    },

    bgColor() {
      return this.currentPayload.background ? this.currentPayload.background : '#F3F3F3';
    }

  }
};